module.exports = __webpack_public_path__ + "img/swift2021.e3fea59b.svg";